import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LanguageState {
    language: 'en' | 'mr'; // Simplified to match standard codes
}

const initialState: LanguageState = {
    language: 'en',
};

const languageSlice = createSlice({
    name: 'language',
    initialState,
    reducers: {
        setLanguage: (state, action: PayloadAction<'en' | 'mr'>) => {
            state.language = action.payload;
            // Optional: Save to localStorage for persistence
            localStorage.setItem('appLanguage', action.payload);
        },
    },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
